// Discount maths for a sale-wide promotion. Every amount is in cents; `rate` is
// a cent amount for a flat discount and whole percents for a percent discount.
//
// Results are rounded to the cent because `sales.total_amount_cents` is an
// integer column — a fractional result would be truncated on the way in and the
// printed receipt would no longer match the daily report — and floored at zero
// because a discount larger than the basket is a data-entry slip, not a sale
// that owes the customer money (refunds go through a refunding payment type).
const toPayableCents = (amountCents: number) =>
	Math.max(0, Math.round(amountCents));

export const flatPromotionType = {
	calculatePrice: (price = 0, rate = 0) => toPayableCents(price - rate),
	key: "flat_discount" as const,
};
// `price * (100 - rate)` stays an exact integer, so the only rounding is the
// final one -- the API recomputes the total that way and refuses a sale whose
// total is off by a cent. `price * (1 - rate / 100)` drifts below a half cent:
// 25 at 34% comes to 16.499… instead of 16.5, and rounds down.
export const percentPromotionType = {
	calculatePrice: (price = 0, rate = 0) =>
		toPayableCents((price * (100 - rate)) / 100),
	key: "percent_discount" as const,
};

export default [flatPromotionType, percentPromotionType];
